<template>
  <b-toast
    id="loading-toast-global-component"
    variant="success"
    :toaster="data.toaster || 'b-toaster-top-center'"
    solid
    no-auto-hide
    no-close-button
    :visible="data.visible"
  >
    <template #toast-title>
      <div class="d-flex flex-grow-1 align-items-center pt-2">
        <b-spinner label="Spinning" small></b-spinner>
        <strong class="mr-auto pl-3"> {{ data.loadingText || 'Memuat data ...' }} </strong>
        <small class="text-muted mr-2">
          <time-ago :datetime="data.startTime" locale="id"></time-ago>
        </small>
      </div>
    </template>
    <p class="mb-0">Progress:</p>
    <b-progress class="mt-2" :max="100" :variant="data.progress | parse('progressVariant')" show-progress animated style="width: 100%;">
        <b-progress-bar :value="data.progress">
            <span>
                <strong>{{ data.progress | parse('prosen') }}</strong>
            </span>
        </b-progress-bar>
    </b-progress>
  </b-toast>
</template>

<script>
export default {
  name: 'NurseryFeLoadingProgresss',

  props: {
    data: {
        type: Object,
        default: () => ({})
    },
  },

  data() {
    return {
    };
  },

  mounted() {
  },

  methods: {
    
  },
};
</script>


// WEBPACK FOOTER //
// src/base/component/loading-progress.vue